module.exports = __webpack_public_path__ + "img/2-2.bc177955.png";